import { useEffect, useState } from 'react';
import { api } from '@/api/repository/axios';
import { unwrapList } from './couponFormat';

/**
 * MY 메뉴·드로어의 "쿠폰 N장" — 사용 가능한 내 쿠폰 수.
 * 쿠폰을 받거나 코드를 등록하면 notifyCouponCountChanged() 로 다시 센다. 실패(서버에 API 없음 등)면 null → 숫자 숨김.
 */

const EVENT_NAME: string = 'myungchisa:coupon-count-changed';

export const notifyCouponCountChanged = (): void => {
    window.dispatchEvent(new Event(EVENT_NAME));
};

export const useMyCouponCount = (enabled: boolean): number | null => {
    const [count, setCount] = useState<number | null>(null);

    useEffect(() => {
        if (!enabled) {
            setCount(null);
            return undefined;
        }
        let alive: boolean = true;
        const load = (): void => {
            // 수만 주는 API 우선, 없으면 목록 길이
            api.coupon.count()
                .then((res) => {
                    if (res?.code === 0 && typeof res.result?.available === 'number') {
                        if (alive) setCount(res.result.available);
                        return;
                    }
                    throw new Error('no count');
                })
                .catch(() => api.coupon.mine('AVAILABLE', { skipAuthHandler: true })
                    .then((res) => { if (alive) setCount(res?.code === 0 ? unwrapList(res.result).length : null); })
                    .catch(() => { if (alive) setCount(null); }));
        };
        load();
        window.addEventListener(EVENT_NAME, load);
        return () => {
            alive = false;
            window.removeEventListener(EVENT_NAME, load);
        };
    }, [enabled]);

    return count;
};
